import React from "react";

import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingPage({ texto, zIndex = 100, className = "" }) {
  return (
    <div
      className={`loading-screen ${className}`}
      style={{ position: "absolute", zIndex, width: "100%" }}
    >
      <CircularProgress color="inherit" size={60} />
      <div style={{textAlign:"center", marginTop: 20, color: "white", fontSize: 18 }}>
        {texto || "Cargando estilos..."}
      </div>
    </div>
  );
}
